







































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import UniformDto from '@/models/Uniforms/UniformDto'
import GiganautVue from '@/components/Shared/GiganautVue';
import UniformCreate from '@/components/Uniforms/UniformCreate.vue';
import UniformEdit from '@/components/Uniforms/UniformEdit.vue';

@Component({
  name: 'Uniforms',
  components: { UniformCreate, UniformEdit }
})
export default class extends GiganautVue {

    async beforeMount() {
        AgencySettingsModule.updateCurrentUniform(null);
    }

    async updateCurrentUniform(uniform: UniformDto) {
        await AgencySettingsModule.updateCurrentUniform(uniform);
    }

    get currentUniform() {
        return AgencySettingsModule.currentUniform;
    }

    get loadingUniforms() {
        return AgencySettingsModule.loadingUniforms;
    }

    get uniforms() {
        return AgencySettingsModule.uniforms;
    }
}
